<template>
  <div id="market-navigation-drawer-modal">
    <v-row justify="center">
      <v-dialog
        v-model="active"
        scrollable
        max-width="300px"
        content-class="vdialogmarketnavdrawer"
      >
        <v-card>
          <v-card-title>{{ $t('selectMarket') }}</v-card-title>
          <v-card-actions>
            <v-text-field :label="$t('search')" v-model="search">
            </v-text-field>
          </v-card-actions>
          <!--                    <v-divider></v-divider>-->
          <v-card-text style="min-height: 300px; height: auto">
            <v-radio-group v-model="dialogm1" column>
              <v-radio
                v-for="(market, i) in marketsFiltered"
                @click="
                  doAction({ marketName: market.name, marketId: market.id })
                "
                :key="i"
                :label="market.name"
                :value="market.name"
              >
              </v-radio>
            </v-radio-group>
          </v-card-text>
          <!--                    <v-divider></v-divider>-->
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import filter from 'lodash/filter'

export default {
  name: 'MarketNavigationDrawerModal',
  props: {
    marketsList: {},
    sportCategoryTournamentInfo: {},
  },
  data: () => ({
    dialogm1: '',
    dialog: true,
    marketSelected: null,
    marketsTransformedList: [],
    active: false,
    initialized: false,
    search: null,
  }),
  computed: {
    ...mapGetters({
      getMarketsGroupsIdActive: 'odds/getMarketsGroupsIdActive',
      getConfiguredGroupsMarkets: 'odds/getConfiguredGroupsMarkets',
    }),
    getGroupMarketActiveForTournament() {
      const vm = this

      let groupMarketActive = null

      const marketsGroupActives = this.getMarketsGroupsIdActive

      const marketGroupSelectedForThisTournament = filter(
        marketsGroupActives,
        function (groupMarket) {
          return (
            groupMarket.tournamentId ==
            vm.sportCategoryTournamentInfo.tournament.id
          )
        }
      )

      if (
        marketGroupSelectedForThisTournament != null &&
        marketGroupSelectedForThisTournament.length > 0
      ) {
        groupMarketActive = marketGroupSelectedForThisTournament[0]
      }

      return groupMarketActive != null
        ? groupMarketActive.groupNameSelected
        : 'ERROR'
    },

    marketsFiltered() {
      if (this.search != null && this.search != '') {
        return this.marketsTransformedList.filter(el => {
          return el.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.marketsTransformedList
      }
    },
  },
  methods: {
    ...mapActions({}),

    doAction(market) {
      this.active = false

      const eventObj = {
        object: this.sportCategoryTournamentInfo,
        market: market.marketId,
        marketId: market.marketId,
        marketName: market.marketName,
      }
      this.$root.$emit('getOddsForMarket', eventObj)
    },
    initializeMarketSelector(fromMount = false) {
      // console.log('initializeMarketSelector')

      const vm = this

      this.marketsTransformedList = []

      for (const market of this.marketsList) {
        //console.log(market)
        const marketMini = {
          id: market.id,
          unique_id: market.unique_id,
          sort: market.sort,
          sortMobile: market.sortMobile,
          name: market.detail[0].text,
        }

        this.marketsTransformedList.push(marketMini)
      }
      if (this.marketsTransformedList.length > 0) {
        this.marketSelected = this.marketsTransformedList[0]
      }

      this.active = false

      if (this.initialized === true) {
        setTimeout(() => {
          vm.active = true // fix me this is a working around problem
        }, 200)
      }

      this.initialized = true
    },

    enableScroll() {
      // todo check if works inside  iframe
      document.body.style.overflow = 'auto'
      document.body.style.height = 'auto'
    },

    disableScroll() {
      // todo check if works inside  iframe
      document.body.style.overflow = 'hidden'
      document.body.style.height = '100%'
    },
  },
  watch: {
    marketsList(newList, oldList) {
      // console.log('watch marketsList inside market select component')
      // console.log('newList', newList)
      // console.log('oldList', oldList)
      if (newList != null && newList.length > 0) {
        this.initializeMarketSelector()
      }
    },
    active(newValue, oldValue) {
      if (newValue === true) {
        this.disableScroll()

        // const sportIframeHeight = document.getElementById('sport-iframe').clientHeight;
        // console.log('sportIframeHeight is', sportIframeHeight);
        //
        // if(sportIframeHeight < 650 ){
        //     document.getElementById('sport-iframe').style.height= "700px";
        //     console.log('sportIframeHeight moved to 700', sportIframeHeight);
        // }
      } else {
        this.enableScroll()
      }
    },
  },
  mounted() {
    // console.log('[DEBUG] mounted the component MarketnavigationDrawer')

    const vm = this
    this.initializeMarketSelector()

    this.$root.$on('openMarketNavigationDrawer', () => {
      vm.active = !vm.active
    })
  },
  beforeDestroy() {
    this.$root.$off('openMarketNavigationDrawer', () => {
      // console.log('destroyed')
    })
  },
}
</script>
